import {
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import {
  AnalyticsService,
  AuthorizationService,
  ToastrService,
  ManualsDownloadedData,
  ExportService,
  ManualDownloadedDataPoint,
  LoggingService,
} from "app/shared";
import { ManualsDownloadedMostConfig } from "app/shared/model/charts/user-analytic-configurations.model";
import { BaseChartLogic } from "app/analytics/BaseChartLogic";

@Component({
  selector: "manuals-downloaded-most-chart",
  templateUrl: "../../common-chart-template.component.html",
  standalone: false,
})
export class ManualsDownloadedMostChartComponent
  extends BaseChartLogic<ManualsDownloadedMostConfig, ManualsDownloadedData>
  implements OnInit, OnDestroy
{
  @Input() startDate: Date | null = null;
  @Input() endDate: Date | null = null;
  @Input() showTitle: boolean = true;
  @ViewChild("chartCanvas") chartCanvas!: ElementRef<HTMLCanvasElement>;

  constructor(
    _analyticsService: AnalyticsService,
    _authService: AuthorizationService,
    _exportService: ExportService,
    _toastrService: ToastrService,
    _loggingService: LoggingService,
    _ngZone: NgZone
  ) {
    super(
      _analyticsService,
      _authService,
      _exportService,
      _toastrService,
      _loggingService,
      ManualsDownloadedMostConfig,
      _ngZone
    );
    this.handleDataSubscription(
      this.analyticsService.manualsDownloadedMostDataChange
    );
  }

  dataPointKey: string = "Total";
  getDataPointDisplayValue(dataPoint: ManualDownloadedDataPoint): any {
    return dataPoint.Total;
  }

  buildFilterSettings(): void {
    this.addPeriodtoFilterSettings();
    this.addStartEndDatesToFilterSettings(this.startDate, this.endDate);
    this.filterSettings.LimitResults = this.config?.top || null;
  }

  refreshData(): void {
    this.analyticsService.getMostDownloadedManualsData(this.filterSettings);
  }

  ngOnInit(): void {
    super.init();
  }

  ngOnDestroy(): void {
    super.cleanup();
  }
}
